<template>
  <!--<div class="container">-->
  <div class="columns is-vcentered is-desktop is-mobile is-full-height is-centered">
    <!--<div class="column is-half  ">-->
    <!--<img class="login-logo" src="@/assets/img/digi-logo.png">-->
    <!--</div>-->
    <div class="column is-6 login-splash is-full-height is-hidden-mobile is-relative">
      <template v-if="!loading">
        <img v-if="!isWhiteLabeled" alt="Login lightbulb" class="is-fullwidth is-full-height"
             src="@/assets/img/login-lightbulb.jpg"
             style="object-fit: cover;width: 100%">
        <img v-else alt="Login lightbulb" class="is-fullwidth is-full-height" :src="applyImage"
             style="object-fit: cover;width: 100%">
      </template>
    </div>

    <div class="column is-6-desktop is-10-mobile login-form">
      <div class="columns is-centered">
        <div class="column is-4">
          <template v-if="!loading">
            <img alt="Login logo" class="login-logo"
                 v-if="!isWhiteLabeled"
                 src="https://generation-sis-assets.s3.eu-west-1.amazonaws.com/images/genex-logo-02.svg"/>
            <img alt="Login logo" class="login-logo"
                 v-else
                 :src="expandedLogoUrl"
            />
          </template>
        </div>
      </div>
      <div class="columns is-centered">
        <div class="column is-8">
          <div class="login">
            <div class="login-content">
              <!--<img class="login-logo" src="@/assets/img/genex-logo.svg">-->

              <div class="login-form">
                <form v-on:submit.prevent="login">

                  <b-field>
                    <b-input v-model="email" autofocus

                             placeholder="Email" required />
                  </b-field>


                  <b-field>
                    <b-input
                        v-model="password"
                        placeholder="Password"
                        required
                        type="password"
                    />
                  </b-field>


                  <b-field grouped>
                    <p class="control">
                      <b-button native-type="submit" type="is-primary">
                        Sign In
                      </b-button>
                    </p>

                    <p class="control">
                      <b-button @click="forgotPassword" type="is-warning">Forgot password</b-button>
                    </p>
                  </b-field>

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--</div>-->
</template>

<script>
import {TenantClient} from "../../clients/Tenant";
import {LoginClient} from "../../clients/Login";
import {VUE_APP_CLIENT_ID, VUE_APP_CLIENT_SECRET} from "../../Variables";
import {mapGetters, mapState} from "vuex";
import Store from "@/store";
import User from "@/models/lms/User";
import GenexUtils from "@/utils/GenexUtils";
import index from "@/router";


export default {
  name: "Login",
  data() {
    return {
      email: null,
      password: null,
      previousUrl: window.prev,
      loading: true
    };
  },
  props: {
    tenant: {
      type: String,
      default: null,
    }
  },
  computed: {
    ...mapState("tenant", {
      lmsTenantId: (state) => state.id,
    }),
    ...mapGetters("tenant", ["expandedLogoUrl", "isWhiteLabeled", "applyImage"])
  },
  async mounted() {
    if(this.$route.query.email) {
      this.email = this.$route.query.email;
    }
    await this.fetchSluggedTenant();
    localStorage.removeItem("vuex");
  },
  methods: {
    async checkActiveTenant(user) {
      if(user.active !== 1 && user.is_super_admin !== 1){
        this.$buefy.toast.open({
          message: "Your access has been suspended. Please contact your organisation for assistance.",
          type: "is-danger",
          duration: 3000
        });
        await this.$store.dispatch("auth/delete");
        await this.$store.dispatch("tenant/logout");
        this.loading = false
        return null;
      }
    },
    forgotPassword(){
      if (this.tenant && isNaN(this.tenant) && this.isWhiteLabeled){
        this.$router.push({ path: `/forgot-password/${this.tenant}` });
      }
      else{
        this.$router.push({ path: `/forgot-password` });
      }
    },
    async fetchSluggedTenant() {
      this.loading = true
      if (!this.tenant) {
        this.loading = false
        return;
      }
      if(this.tenant && isNaN(this.tenant)){

        const [error, response] = await this.$error(() => TenantClient.getTenantsFromSlug(this.tenant));

        if (error) {
          this.loading = false
          await this.$router.push({name: "auth.login"});
          return;
        }

        const {data} = response
        const slug = data[0].slug ?? null;
        const school_name = data[0].school_name ?? null;
        const is_white_labeled = data[0].is_white_labeled === 1 ? true : false;

        if(!is_white_labeled){
          this.$router.replace('/login'); //replace route slug to general /login if tenant is not white labeled
        }
        if(data[0].active === 1 || data[0].is_super_admin === 1){
          //storing tenant slug & school name on fetched tenant via custum url.
          if(slug && school_name && is_white_labeled){
            this.$cookies.set('tenant_slug', slug);
            this.$cookies.set('tenant_school_name', school_name);
            this.$cookies.set("tenant_is_white_labeled", 1)
          }

          this.$store.commit("tenant/setTenantData", data[0]);
          this.loading = false
        }
        if (data.length === 0) {
          await this.$store.dispatch("auth/delete");
          await this.$store.dispatch("tenant/logout");
          this.loading = false
          return null;
        }   
      }
    },
    async getTenant() {
      this.$cookies.remove('tenant_slug'); //remove any existing slug in cookies before getting a tenant.
      if (this.lmsTenantId) {
        return this.$store.state.tenant
      }
      const [error, {data}] = await this.$error(() => TenantClient.getTenants(this.email));
      if (error) {
        this.handleError(error);
        return null
      }   
      if (data.length === 0) {
        await this.$store.dispatch("toast/createToast", {
          message: 'Unable to find your account. Please contact your school campus.',
        });
        return null
      }
      await this.checkActiveTenant(data[0]);
      
      if(data[0].active === 1 || data[0].is_super_admin === 1){
        //storing tenant slug & school name if tenant is retrieved.
        const slug = data[0].slug ?? null;
        const school_name = data[0].school_name ?? null;
        if(slug && school_name){
          this.$cookies.set('tenant_slug', slug);
          this.$cookies.set('tenant_school_name', school_name);
        }
        return data[0];
      }
    },
    async login() {
      try {
        // Store.dispatch("loader/show");
        await Store.dispatch('loader/show', 'Logging in...');
        const tenant = await this.getTenant();
        if (tenant) {
          this.$cookies.set("lmsTenantId", tenant.id);
          if (tenant.sis_storage) {
            this.$cookies.set("tenant_sis_storage", tenant.sis_storage)
          }
          if (tenant.is_white_labeled === 1) {
            this.$cookies.set("tenant_is_white_labeled", 1)
          }
          await this.$store.commit("tenant/setTenantData", tenant)
          const response = await LoginClient.login({
            email: this.email,
            password: this.password,
            grant_type: 'password',
            client_id: VUE_APP_CLIENT_ID,
            client_secret: VUE_APP_CLIENT_SECRET
          }, {
            'X-Tenant': tenant.id
          })
          if (response.data.chat) {
            await this.$store.dispatch("cometChat/setChatDetails", response.data.chat);
          } else {
            await this.$store.dispatch("cometChat/setChatDetails", {});
          }
          this.$cookies.set("lmsAccessToken", response.data.access_token);
          localStorage.setItem("lmsAccessToken", response.data.access_token)
          setTimeout(async () => {
            // window.location.href = this.previousUrl || "/dashboard";

            try {
              await GenexUtils.getAuthDetailsAndSaveThem()
              const { state } = Store;
              if(state.auth.user.id !== undefined && state.auth.user.id !== null) {

                User.LoginIntoSIS(state.auth.user.id)
                    .then(response => {
                      if (response.response.data) {
                        const auth = response.response.data;

                        const sisAccessToken = auth.access_token;
                        GenexUtils.setCookie("sisAccessToken", sisAccessToken, 1);

                        const sisTenantId = auth.sis_tenant_id;
                        GenexUtils.setCookie("sisTenantId", sisTenantId, 1);

                        Store.dispatch("loader/hide");

                        Store.dispatch("toast/createToast", {
                          message: "Logged in successfully",
                          type: "is-success",
                        });

                        this.$router.push({
                          path: "/dashboard",
                        })
                      }

                    })
                    .catch(err => {
                      this.handleError(err);
                    });
              }
            } catch (e){


              await Store.dispatch("loader/hide");
              const { state } = Store;

              state.requestedHandshake = true;
              await Store.dispatch("toast/createToast", {
                message: "Please login to continue",
              });
              await Store.dispatch("auth/delete");
              await Store.dispatch("tenant/logout");
              await index.push({ name: "auth.login" });
            }

          }, 2000)
        } else {
          await Store.dispatch("loader/hide");
        }
      } catch (error) {

        await Store.dispatch("loader/hide");
        this.handleError(error);
      }
    },
  },
};
</script>
